import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  Typography,
  CircularProgress,
} from "@mui/material";
import { Stack } from "@mui/system";
import EasySellBuy from "../../../pages/easysellbuy";
import axios from "axios";

interface Currency {
  id: number;
  name: string;
  icon_link: string;
  description?: string;
}

const CurrencyDetail = () => {
  const { id } = useParams<{ id: string }>();
  const [currency, setCurrency] = useState<Currency | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCurrency = async () => {
      try {
        const response = await axios.get(
          `https://api-panel.parsianbit.com/publish/v1/currency/${id}`
        );

        const fetchedCurrency = response.data?.data;
        setCurrency(fetchedCurrency);
        document.title = fetchedCurrency?.name || "جزئیات ارز";
        setLoading(false);
      } catch (err) {
        console.error("Error fetching currency details:", err);
        setError("خطا در دریافت اطلاعات ارز");
        setLoading(false);
      }
    };

    fetchCurrency();
  }, [id]);

  if (loading)
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress />
      </Box>
    );

  if (error) return <Typography>{error}</Typography>;

  if (!currency) return <Typography>داده‌ای برای نمایش وجود ندارد.</Typography>;

  return (
    <Box
      bgcolor={"background.default"}
      sx={{
        pt: 6,
        pb: 8,
        textAlign: "center",
      }}
    >
      <Container>
        <Typography variant="h5" component="h1" sx={{ color: "text.title" }}>
          خرید {currency.name}
        </Typography>
        <Box>
          <Grid
            container
            spacing={3}
            sx={{
              justifyContent: "space-between",
              alignItems: "center",
              mt: 0.5,
            }}
          >
            <Grid item xs={12} md={6} lg={4}>
              <Stack alignItems={"center"} direction={"row"} spacing={2}>
                <Box>
                  <img
                    src={currency.icon_link}
                    alt={`${currency.name} icon`}
                    width="100%"
                  />
                </Box>
                <Stack>
                  <Typography
                    variant="h6"
                    component="p"
                    sx={{ color: "text.title", textAlign: "start" }}
                  >
                    {currency.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "text.secondary", textAlign: "start" }}
                  >
                    {currency.description ||
                      "توضیحاتی برای این ارز موجود نیست."}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </Box>
      </Container>
      <EasySellBuy />
    </Box>
  );
};

export default CurrencyDetail;
